import { ReadonlyVec3, ReadonlyVec4, glMatrix } from 'gl-matrix';
import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export class UniformVec4 extends Uniform {
    constructor(name: string) {
        super(name);
    }

    public loadVec4(vector: Array<number>): void;

    public loadVec4(x: number, y: number, z: number, w: number): void;

    public loadVec4(vector: {
        x: number;
        y: number;
        z: number;
        w: number;
    }): void;

    public loadVec4(vector: ReadonlyVec3, w: number): void;

    public loadVec4(vector: ReadonlyVec4): void;

    loadVec4(
        vector:
            | Array<number>
            | { x: number; y: number; z: number; w: number }
            | ReadonlyVec4
            | ReadonlyVec3
            | number,
        y?: number,
        z?: number,
        w?: number
    ): void {
        if (this.location) {
            if (
                vector instanceof Array ||
                vector instanceof glMatrix.ARRAY_TYPE ||
                vector instanceof Float32Array
            ) {
                if (vector.length === 4) {
                    gl.uniform4fv(this.location, vector);
                } else {
                    gl.uniform4f(
                        this.location,
                        vector[0],
                        vector[1],
                        vector[2],
                        y as number
                    );
                }
            } else if (typeof vector == 'number') {
                gl.uniform4f(
                    this.location,
                    vector,
                    y as number,
                    z as number,
                    w as number
                );
            } else {
                gl.uniform4f(
                    this.location,
                    vector.x,
                    vector.y,
                    vector.z,
                    vector.w
                );
            }
        }
    }
}
